export default __webpack_public_path__ + "static/media/bannersWEBINAR_28mayo.e8ba9772.jpg";